import { MoneyFormatter, StringFormatter } from 'namirasoft-site-react';
import Styles from './NSPOfferItemCardPriceLine.module.css';

export interface NSPOfferItemCardPriceLineProps
{
	image: string | null;
	price: number;
	currency: string;
	name: string;
	description?: string;
}

export function NSPOfferItemCardPriceLine(props: NSPOfferItemCardPriceLineProps)
{
	return <>
		<div
			className={Styles.nsp_offer_item_card_price_line_parent}
		>
			<div
				className={Styles.nsp_offer_item_card_price_line_first}
			>
				{
					props.image &&
					<img src={props.image} alt={props.name} />
				}
				<p className={`${Styles.nsp_offer_item_card_price_line_first_price}`}>{new MoneyFormatter(undefined, props.currency, 0, 5).format(props.price)}</p>
				<p className={`${Styles.nsp_offer_item_card_price_line_first_text}`}>{props.name}</p>
			</div>
			{
				props.description &&
				<div
					className={Styles.nsp_offer_item_card_price_line_description_parent}
				>
					<p className={Styles.nsp_offer_item_card_price_line_description}>{StringFormatter.toHTML(props.description)}</p>
				</div>
			}
		</div>
	</>
}